import templateUrl from 'emun.customer/dealers/dealer-prompt.htm'
import DealerPromptController from 'emun.customer/dealers/dealer-prompt.controller'
//import resolve from 'ioc/resolve'
import modals from 'webmodals/modals'

const DealerPrompt = {
	open(options) {
		return modals.open(angular.extend({
			size: 'lg',
			templateUrl,
			resolve: {
				options: () => options
			},
			bindToController: true,
			controller: DealerPromptController,
			controllerAs: '$ctrl'
		}, (options || {}).modal)).result;
	}
};

export default DealerPrompt;